import React, { useState, useContext } from 'react';
import { ResultContext } from '../contexts/ResultContext';




const PaginationComponent = () => {
    const { result } = useContext(ResultContext);

    const data = result?.celery_status?.result?.sample_customers_data || []

    const ITEMS_PER_PAGE = 30;

    const [currentPage, setCurrentPage] = useState(1);

    const totalPages = Math.ceil(data?.length / ITEMS_PER_PAGE);
    const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
    const selectedData = data?.slice(startIndex, startIndex + ITEMS_PER_PAGE);

    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };


    return (
        <div className="p-4 max-w-3xl mx-auto">
            <h2 className="text-xl font-bold mb-4">Customer Data</h2>

            <table className="w-full border">
                <thead>
                    <tr className="bg-gray-200">
                        <th className="p-2 border">CustomerID</th>
                        <th className="p-2 border">Recency</th>
                        <th className="p-2 border">Frequency</th>
                        <th className="p-2 border">Monetary</th>
                        <th className="p-2 border">RFMScore</th>
                        <th className="p-2 border">Segment</th>
                    </tr>
                </thead>
                <tbody>
                    {selectedData?.map((item) => (
                        <tr key={item.CustomerID}>
                            <td className="p-2 border">{item.CustomerID}</td>
                            <td className="p-2 border">{item.Recency}</td>
                            <td className="p-2 border">{item.Frequency}</td>
                            <td className="p-2 border">{item.Monetary}</td>
                            <td className="p-2 border">{item.RFMScore}</td>
                            <td className="p-2 border">{item.Segment}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {/* Pagination Controls */}
            <div className="flex justify-center mt-4 space-x-2">
                <button
                    className="px-3 py-1 border rounded disabled:opacity-50"
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                >
                    Previous
                </button>

                {[...Array(totalPages)].map((_, idx) => (
                    <button
                        key={idx}
                        className={`px-3 py-1 border rounded ${currentPage === idx + 1 ? 'bg-blue-500 text-white' : ''
                            }`}
                        onClick={() => handlePageChange(idx + 1)}
                    >
                        {idx + 1}
                    </button>
                ))}

                <button
                    className="px-3 py-1 border rounded disabled:opacity-50"
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                >
                    Next
                </button>
            </div>
        </div>
    );
};

export default PaginationComponent;
